import * as Sentry from '@sentry/react';

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment: import.meta.env.VITE_ENVIRONMENT,
  debug: import.meta.env.VITE_ENVIRONMENT !== 'prod',
});

export const captureError = (error: unknown, context?: Record<string, unknown>) => {
  Sentry.captureException(error, context ? { extra: context } : undefined);
};
